import { render, staticRenderFns } from "./ClubInfoBanner.vue?vue&type=template&id=d7baf7ae&scoped=true&"
import script from "./ClubInfoBanner.vue?vue&type=script&lang=js&"
export * from "./ClubInfoBanner.vue?vue&type=script&lang=js&"
import style0 from "./ClubInfoBanner.vue?vue&type=style&index=0&id=d7baf7ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7baf7ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7baf7ae')) {
      api.createRecord('d7baf7ae', component.options)
    } else {
      api.reload('d7baf7ae', component.options)
    }
    module.hot.accept("./ClubInfoBanner.vue?vue&type=template&id=d7baf7ae&scoped=true&", function () {
      api.rerender('d7baf7ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Club/components/core/ClubInfoBanner/ClubInfoBanner.vue"
export default component.exports